import React, { useEffect, useState } from "react";
import authService from "../../services/authService";
import Amplify, { Auth } from "aws-amplify";
import awsconfig from "../../aws-config";
import assessmentLocalStoreg from "../../services/assessmentLocalStoreg";
import Joi from "@hapi/joi";
import notification from "../../services/notification"

Amplify.configure(awsconfig);

const initialFormState = {
  name: "",
  email: "",
  phoneNumber: "",
  oldPassword: "",
  password: "",
  confirmPassword: "",
};

const schema = {
  name: Joi.string().alphanum().min(3).max(30).required(),
  email: Joi.string()
    .email({ minDomainSegments: 2, tlds: { allow: ["com", "net"] } })
    .label("Email"),
  phoneNumber: Joi.string().required().label("Phone Number"),
  oldPassword: Joi.string(),
  password: Joi.string(),
  confirmPassword: Joi.string(),
};

export default function Profile({ hideLoadingValue, showLoadingValue, history }) {
  const [form, setForm] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    try {
      const result = await authService.getUserInfo();
      if (result) {
        const idToken = result.getIdToken();
        if (idToken) {
          const user = idToken.decodePayload();
          setForm({
            name: user.name,
            email: user.email,
            phoneNumber: user.phone_number,
          });
        }
      }
    } catch (error) {}
  };

  const handleSignOut = async () => {
    try {
      showLoadingValue()
      await Auth.signOut();
      assessmentLocalStoreg.deleteAnswer();
      localStorage.removeItem("userInfo");
      history.push("");
    } catch (error) {
      console.log("error signing out: ", error);
      hideLoadingValue();
      notification.error(error.message)
    }
    hideLoadingValue();
  };

  const handleChangePassword = async () => {
    try {
      showLoadingValue()
      const user = await Auth.currentAuthenticatedUser();
      const result = await Auth.changePassword(user, form.oldPassword, form.password);
      console.log(result);
    } catch (error) {
      console.log("error Change Password: ", error);
      hideLoadingValue();
      notification.error(error.message)
    }
    hideLoadingValue();
  };

  const handleEditProfile = async () => {
    try {
      showLoadingValue()
      const user = await Auth.currentAuthenticatedUser();
      const result = await Auth.updateUserAttributes(user, {
        name: form.name,
        email: form.email,
        phone_number: form.phoneNumber,
      });
      console.log(result); // SUCCES
    } catch (error) {
      console.log("error Edit Profile: ", error);
      hideLoadingValue();
      notification.error(error.message)
    }
    hideLoadingValue();
  };

  const handleChange = ({ currentTarget: input }) => {
    const errorMessage = validateProperty(input);
    if (errorMessage) {
      setErrors({
        ...errors,
        [input.name]: errorMessage,
      });
    } else {
      delete errors[input.name];
      setErrors(errors);
    }

    setForm({
      ...form,
      [input.name]: input.value,
    });
  };

  const validateProperty = ({ name, value }) => {
    const userInputObject = { [name]: value };
    const propertySchema = Joi.object({ [name]: schema[name] });
    const { error } = propertySchema.validate(userInputObject, {
      abortEarly: true,
    });
    return error ? error.details[0].message : null;
  };

  return (
    <>
      <div className="form-profile">
        <div className="row">
          <input
            type="text"
            className="auth-form-controller"
            name="name"
            placeholder="Name"
            value={form.name}
            onChange={handleChange}
          />
        </div>
        <div className="row">
          <input
            type="email"
            className="auth-form-controller"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
          />
        </div>
        <div className="row">
          <input
            type="text"
            className="auth-form-controller"
            name="phoneNumber"
            placeholder="Phone Number"
            value={form.phoneNumber}
            onChange={handleChange}
          />
        </div>
        <div className="row">
          <div className="col s12 center-align padding0">
            <button
              className="waves-effect waves-light submit-button"
              onClick={handleEditProfile}
            >
              EDIT
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col s12 center-align padding0">
            <button
              className="waves-effect waves-light submit-button red"
              onClick={handleSignOut}
            >
              SIGN OUT
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col s12 center-align padding0">
            <div className="row">
              <input
                type="password"
                className="auth-form-controller"
                name="oldPassword"
                placeholder="Old Password"
                onChange={handleChange}
              />
            </div>
            <div className="row">
              <input
                type="password"
                className="auth-form-controller"
                name="password"
                placeholder="Password"
                onChange={handleChange}
              />
            </div>
            <div className="row">
              <input
                type="password"
                className="auth-form-controller"
                name="confirmPassword"
                placeholder="Confirm Password"
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col s12 center-align padding0">
            <button
              className="waves-effect waves-light submit-button red"
              onClick={handleChangePassword}
            >
              CHANGE PASSWORD
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
